import {EventEmitter, Inject, Injectable, Output} from '@angular/core';
import {PdfInstanceManagerService} from './instance/pdf-instance-manager.service';
import {FileConvertorService} from './file-convertor/file-convertor-service';
import * as FileSaver from 'file-saver';
import {BlobToPdfService} from './blob-to-pdf.service';
import {TabService} from './tab.service';
// import {ModalWindowService} from './ui/modal-window.service';
// import {CommonMessageDialogComponent} from '../components/dialogs/common-message-dialog/common-message-dialog.component';
import { AutosaveManagerService } from './autosave/autosave-manager.service';
import { ToastrActionEnum } from '../utils/enums';
import { TranslateService } from '@ngx-translate/core';
import { ToastrDialogService } from './toastr-dialog.service';
import { EpubFileService } from './epub/epub-file.service';


@Injectable({
  providedIn: 'root'
})
export class SaveService {
  @Output() SaveFileFired: EventEmitter<any> = new EventEmitter();
  pdfManager: PdfInstanceManagerService;

  constructor(
    @Inject(PdfInstanceManagerService) pdfManager: PdfInstanceManagerService,
    private rtfService: FileConvertorService,
    private blobToPdfService: BlobToPdfService,
    private epubFileService: EpubFileService,
    private tabService: TabService,
    // private modalService: ModalWindowService,
    private readonly autosave: AutosaveManagerService,
    private readonly translate: TranslateService,
    private readonly toastrService: ToastrDialogService,
  ) {
    this.pdfManager = pdfManager;
    this.readyToDLSub();
  }

  readyToDLSub() {
    this.rtfService.FileReadyForDL.subscribe((file) => {
        this.downloadRTF(file);
    });
  }

  downloadRTF(file) {
      if (file.type === 'application/rtf' || file.type === 'text/rtf') {
        let filename = file.name;
        filename = filename.indexOf('.rtf') === -1 ? filename + '.rtf' : filename;
        FileSaver.saveAs(file, filename); // add rtf explicitly or the file will have no type
      }
  }

  async downloadPDF(_activeTabId: string, readingItemIdx: number | null, readingItemPageIdx: number | null = null) {
    const fileToDownload = await this.blobToPdfService.getCurrentPDF();
    if(fileToDownload){
      await this.autosave.addSavedFileAndUpdateReadingPos(fileToDownload, readingItemIdx, readingItemPageIdx);
      if (this.tabService.activeTab && this.tabService.activeTab.isOriginallyKES) {
        // this.tabService.activeTab.isDedicon ?
        //   this.modalService.createModalWindow(CommonMessageDialogComponent, {messageKey: 'COMMONMESSAGEDIALOG.PDF_SEK_SAVE_SUCCESS'}) :
        //   this.modalService.createModalWindow(CommonMessageDialogComponent, {messageKey: 'COMMONMESSAGEDIALOG.PDF_KES_SAVE_SUCCESS'});

          const message = this.translate.instant(
            this.tabService.activeTab.isDedicon ? 'COMMONMESSAGEDIALOG.PDF_SEK_SAVE_SUCCESS' : 'COMMONMESSAGEDIALOG.PDF_KES_SAVE_SUCCESS'
            );
            this.toastrService.showToaster(ToastrActionEnum.Success, message);
      }
  
      FileSaver.saveAs(fileToDownload);
    }
  }

  async downloadEpubWithAnnotations() {
    const file = await this.epubFileService.exportWithAnnotations();
    FileSaver.saveAs(file);
  }
}
